<template>
  <div class="radios-cdn">
    <div :class="['text-gray-style tip-label', { 'line': hasLine }]">{{label}}</div>
    <el-radio-group v-model="radio" @change="updateValue">
    <el-radio
    v-for="(item, index) in items"
    :key="index"
    :label="item.value">{{item.label}}</el-radio>
  </el-radio-group>
  </div>
</template>

<script>
export default {
  props: {
    value: [Number, String],
    label: String,
    hasLine: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      radio: this.value,
    };
  },
  watch: {
    value(val) {
      this.radio = val;
    },
  },
  methods: {
    updateValue(e) {
      this.$emit('input', e);
    },
  },
};
</script>
<style lang="scss" scoped>
.radios-cdn {
  padding-bottom: 36px;
  .line {
    border-bottom: 1px solid #D7DBEC;
  }
  .tip-label {
     margin-bottom: 26px;
     margin-top: 20px;
  }
}
</style>
